/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import scrollTrigger.js bundle
 */
import { actionToSplash } from "./scrollTrigger/scrollTrigger-splash";

/**
 * hintBrowser
 * will-changeを外す
 */
var willChangeItem = document.querySelectorAll(".hintBrowser");
function hintBrowser() {
  for (let i = 0; i < willChangeItem.length; i++) {
    willChangeItem[i].classList.remove("hintBrowser");
  }
}

/**
 * スプラッシュ
 */
const setSplash = () => {
  window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      actionToSplash()
    }, 1000);
  });
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setSplash };
